module.exports = window["Bernie_l10nBundle_is_IS"];